import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import nb from './locales/nb.json';
import en from './locales/en.json';

export const SUPPORTED_LANGUAGES = ['nb', 'en'] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

// Keep <html lang> in sync so screen readers pick the right pronunciation.
i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng;
});

void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            nb: { translation: nb },
            en: { translation: en },
        },
        fallbackLng: 'nb',
        supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
        nonExplicitSupportedLngs: true,
        interpolation: { escapeValue: false },
        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: 'dekon_lang',
            caches: ['localStorage'],
        },
    })
    .then(() => {
        document.documentElement.lang = i18n.resolvedLanguage ?? 'nb';
    });

export default i18n;
